<app-admin-header></app-admin-header>
<div class="header">
    <app-header></app-header>
</div>
<div class="hero">
    <app-hero></app-hero>
</div>
<app-featured></app-featured>
<app-disciplines></app-disciplines>
<app-promotional-ads></app-promotional-ads>
<app-collections></app-collections>
<app-available-features></app-available-features>
<div class="container">
    <app-localization [addWrapper]="true"></app-localization>
</div>
<app-footer></app-footer>
<app-simplified-footer></app-simplified-footer>
